module.exports = __webpack_public_path__ + "static/media/bannerheade.0d5ad039.png";